<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        SMS NUDGE
        <small>Create A Nudge</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Create A Nudge</li>
      </ol>
    </section>

    <!-- main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-lg-10 col-lg-offset-1">
                <form role="form">
                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="category">Category</label>
                    <nv-select class="form-control" id="category" v-model="config.category">
                      <option value="">--Select category--</option>
                      <option v-for="(caption, value) in categories" :key="value" :value="value">{{caption}}</option>
                    </nv-select>
                  </div>

                  <div v-if="isUsersWithoutMethod" class="form-group col-xs-12 col-sm-6">
                    <label for="reason">Reason</label>
                    <nv-select class="form-control" id="category" v-model="config.reason">
                      <option value="">--Select Reason--</option>
                      <option v-for="(value, key) in allReasonse" :key="key" :value="value">{{ value }}</option>
                    </nv-select>
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="description">Description</label>
                    <textarea v-model="config.description" rows="4" id="description" class="form-control" placeholder="Description" />
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="date-from">Date from</label>
                    <input type="date" v-model="config.from" id="date-from" class="form-control" placeholder="From" />
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="date-to">Date to</label>
                    <input type="date" v-model="config.to" id="date-to" class="form-control" placeholder="To" />
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="keyword">Keyword</label>
                      <vue-tags-input
                        class="form-control"
                        id="tag-input"
                        v-model="currentKeyword"
                        :tags="config.keywords"
                        :add-only-from-autocomplete="true"
                        :autocomplete-items="filteredKeywords"
                        @tags-changed="update"
                      />
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="gender">Gender</label>
                    <nv-select v-model="config.gender" id="gender" class="form-control">
                      <option value="">--choose gender--</option>
                      <option value="man">Male</option>
                      <option value="woman">Female</option>
                    </nv-select>
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="location">Location</label>
                    <input type="text" v-model="config.location" id="location" class="form-control" placeholder="location" />
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="channel">Channel</label>
                    <nv-select v-model="config.channel" id="channel" class="form-control">
                      <option value="">--choose channel--</option>
                      <option v-for="(caption, value) in channels" :key="value" :value="value">{{caption}}</option>
                    </nv-select>
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="requires-response">Requires User Response</label>
                    <nv-select class="form-control" id="requires-response" v-model="config.requiresResponse">
                      <option value="">--Select option--</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </nv-select>
                  </div>

                  <div class="form-group col-xs-12 col-sm-6">
                    <label for="generic-app">Conversation</label>
                    <nv-select v-model="config.genericApp" class="form-control">
                      <option value="">--Select App--</option>
                      <option
                        v-for="(each, key) in allApps"
                        :key="key"
                        :value="each.value">
                          {{each.name}}
                      </option>
                    </nv-select>
                  </div>
                  <br clear="all" />
                  <nudge-message />

                  <button class="btn btn-primary" :disabled="processing" @click="query">Query</button>
                  <br />
                  <h4 v-if="queryCount">The nudge will be sent to {{queryCount}} user(s)</h4>
                  <button :disabled="processing" v-if="queryCount" type="submit" class="btn btn-primary btn-big" @click="nudge">Nudge Users</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- end of content -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input'
import NudgeMessage from './messages'
import { getUser } from '../../../utils/auth'

export default {
  name: 'new-nudge',
  components: {
    'nudge-message': NudgeMessage,
    VueTagsInput
  },
  data () {
    return {
      allReasonse: [
        'It\'s expensive',
        'I\'m still planning to go',
        'Don\'t know the facility',
        'Facility is far away',
        'I don\'t want family planning'
      ],
      categories: {
        'all-users': 'All Users',
        'failed-screening': 'Failed Screening',
        'unredeemed-referral': 'Unredeemed Referral',
        'no-method': 'No Method'
      },
      channels: {
        'sms': 'SMS',
        'messenger': 'Messenger',
        'web': 'Web'
      },
      currentKeyword: '',
      config: {
        // this doesn't work because this https://asknivi.eu.auth0.com/userinfo
        // is not getting userinfo
        creator: getUser().nickname,
        category: '',
        gender: '',
        channel: '',
        keywords: [],
        location: '',
        description: '',
        reason: '',
        from: '',
        to: '',
        genericApp: '',
        requiresResponse: ''
      },
      processing: false
    }
  },
  computed: {
    filteredKeywords () {
      return this.keywords.filter(i => i.text.toLowerCase().indexOf(this.currentKeyword.toLowerCase()) !== -1)
    },
    isUsersWithoutMethod () {
      return this.config.category === 'no-method'
    },
    ...mapState({
      allApps: state => state.general.allApps,
      keywords: state => state.general.keywords.map(each => ({ text: each })),
      queryCount: state => state.nudge.queryCount,
      responseMessage: state => state.nudge.responseMessage
    })
  },
  methods: {
    async query (e) {
      e.preventDefault()
      this.processing = true
      const details = { ...this.config, keywords: this.config.keywords.map(each => each.text) }
      await this.queryUser(details)
      this.processing = false
    },

    async nudge (e) {
      e.preventDefault()
      this.processing = true
      const details = { ...this.config, keywords: this.config.keywords.map(each => each.text) }
      await this.nudgeUsers(details)
      this.processing = false
    },

    update (newTags) {
      this.config.keywords = newTags
    },

    ...mapActions([
      'loadGenericApps',
      'queryUser',
      'nudgeUsers',
      'loadAllKeywords'
    ])
  },
  mounted () {
    this.loadGenericApps()
    this.loadAllKeywords()
  },
  watch: {
    responseMessage (newMessage) {
      if (newMessage.type) {
        this.$swal(newMessage)
      }
    }
  }
}
</script>

<style>
  #tag-input {
    border: none;
    max-width: none;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// new.vue?54046ada